export const BUSINESS = {
    name: "Work Island",
    address: "5-E-45, Jai Narayan Vyas Colony, Near Murti Circle, Bikaner, Rajasthan",
    shortAddress: "Near Murti Circle, Bikaner",
    phone: "8586860979",
    phoneDisplay: "+91 85868 60979",
    email: "info@theworkisland.in",
    // Exact coordinates not yet verified — set lat/lng once confirmed and all map links upgrade automatically
    lat: null,
    lng: null,
};

export const locationQuery = `${BUSINESS.name}, ${BUSINESS.address}`;
const destination =
    BUSINESS.lat && BUSINESS.lng ? `${BUSINESS.lat},${BUSINESS.lng}` : locationQuery;

export const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(destination)}`;
export const googleMapsDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
export const mapEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(destination)}&output=embed`;
export const telUrl = `tel:+91${BUSINESS.phone}`;
export const mailtoUrl = `mailto:${BUSINESS.email}`;
export const whatsappUrl = `https://wa.me/91${BUSINESS.phone}?text=${encodeURIComponent("Hi Work Island, I'd like to know more about your workspaces!")}`;
